

























import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import DataTable from '@/components/datatable.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';
import { User, UsersApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';

import AddUserForm from '@/components/add business objects/add-user/AddUserForm.vue';

@Component({
	components: {
		DataTableWithFilters,
		secondaryNav,
		DataTable,
		AddUserForm,
	},
})
export default class UsersList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'name', label: 'Name', sortable: true },
			{ key: 'email', label: 'Email', sortable: true },
			{ key: 'phone', label: 'Phone', sortable: false },
		],
		loading: false,
		search: null,
		sortBy: 'name',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};
	public filters: DataTableFilter[] = [];

	private api: UsersApi;

	constructor() {
		super();
		this.api = new UsersApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'users-datatable');
	}

	public clickTable(item: User, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'users.view',
				params: { userId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'users.view',
				params: { userId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				filters.push({ field: 'custom', value: this.state.search }); // custom
			}
			const response = await this.api.getUsers(
				ApiUtils.queryOptions(filters, ctx, { params: { include: 'org' } }),
			);
			const body = response.data;

			data = body.data;
			this.state.totalRows = (body.meta && body.meta.total) || 0;
		} catch (e) {
			this.state.totalRows = 0;
			console.log(e);
		}
		return data;
	}
}
